import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'list',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    walletStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.view ?? 'list',
      };
    },
    walletClear: () => initialState,

    walletUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    walletUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    walletUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    walletUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { walletStore, walletClear, walletUpdateIsLoading, walletUpdateIsActive, walletUpdateBlockContent, walletUpdateBlockDesign } = walletSlice.actions;

export const selectWalletIsLoading = (state) => state.wallet.isLoading;

export const selectWalletId = (state) => state.wallet.id;
export const selectWalletUID = (state) => state.wallet.uid;
export const selectWalletSID = (state) => state.wallet.sid;

export const selectWalletBlockContent = (state) => state.wallet.blockContent;
export const selectWalletBlockDesign = (state) => state.wallet.blockDesign;
export const selectWalletSortItems = createSelector([selectWalletBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectWalletItemDesign = (state) => state.wallet.itemDesign;
export const selectWalletButtonDesign = (state) => state.wallet.buttonDesign;
export const selectWalletContainerDesign = (state) => state.wallet.containerDesign;

export default walletSlice.reducer;
